import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Team Members "Pending" table row placeholder — mirrors
 * PendingInvitationsTableHeader.web.tsx / renderPendingInvitationItem's
 * 6-column shape and flex ratios: Email-or-Name / Invited By / Date Sent /
 * Expiration Date / Role / Action.
 */
export const PendingInvitationRowSkeleton: React.FC<{
  testID?: string;
  showActionColumn?: boolean;
}> = ({
  testID = 'pending-invitation-row-skeleton',
  showActionColumn = true,
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='xs'
      paddingHorizontal='m'
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Box flex={2.66} flexDirection='row' alignItems='center'>
        <Skeleton
          variant='circle'
          width={32}
          height={32}
          style={{ marginRight: theme.spacing.xs }}
        />
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={2.4} alignItems='flex-start' justifyContent='center'>
        <Skeleton variant='text' width='70%' />
      </Box>
      <Box flex={1.64} alignItems='flex-start' justifyContent='center'>
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={1.64} alignItems='flex-start' justifyContent='center'>
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={1.2} alignItems='flex-start' justifyContent='center'>
        <Skeleton variant='text' width='50%' />
      </Box>
      {showActionColumn && (
        <Box flex={1.28} alignItems='center' justifyContent='center'>
          <Skeleton variant='rect' width={40} height={20} borderRadius='xxs' />
        </Box>
      )}
    </Box>
  );
};
